<template>
  <div class="faq-bloc">
    <div class="faq-bloc-header">
      <h2>{{$resx('FaqGeneralInformationsText')}}</h2>
    </div>
    <div v-if="!isSaving" class="faq-bloc-body">
      <div class="row">
        <div class="col col-25">
          {{$resx('FaqReceptionSqmSizeText')}}
        </div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.sqmSize===null">?</span>
          <span v-if="!editMode && modelCopy.sqmSize!==null">{{modelCopy.sqmSize}}</span>
          <input v-if="editMode" type="number" v-model.number="modelCopy.sqmSize" min="1" max="200" name="sqmSize" v-validate="'between:1,200'" :class="{'field-validation-error': errors.has('sqmSize')}"/>
        </div>
      </div>
      <div class="row">
        <div class="col col-25">
          {{$resx('FaqReceptionNbPitchesText')}}
        </div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.nbPitches===null">?</span>
          <span v-if="!editMode && modelCopy.nbPitches!==null">{{modelCopy.nbPitches}}</span>
          <input v-if="editMode" type="number" v-model.number="modelCopy.nbPitches" min="0" max="3000" name="nbPitches"  v-validate="'between:0,3000'" :class="{'field-validation-error': errors.has('nbPitches')}"/>
        </div>
        <div class="col col-25">
          {{$resx('FaqReceptionNbRentalsText')}}
        </div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.nbRentals===null">?</span>
          <span v-if="!editMode && modelCopy.nbRentals!==null">{{modelCopy.nbRentals}}</span>
          <input v-if="editMode" type="number" v-model.number="modelCopy.nbRentals" min="0" max="3000" name="nbRentals" v-validate="'between:0,3000'" :class="{'field-validation-error': errors.has('nbRentals')}"/>
        </div>
      </div>
      <div class="row">
        <div class="col col-25">{{$resx('FaqReceptionOpeningDateText')}}</div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.openingDate===null">?</span>
          <span v-if="!editMode && modelCopy.openingDate!==null">{{getFormatedDate(modelCopy.openingDate)}}</span>
          <input v-if="editMode" type="date" v-model="modelCopy.inputOpeningDate" ref="openingDate" name="openingDate" :min="dateMin" :max="dateMax" v-validate="'date_format:yyyy-mm-dd'" :class="{'field-validation-error': errors.has('openingDate')}"/>
        </div>
        <div class="col col-25">{{$resx('FaqReceptionClosingDateText')}}</div>
        <div class="col col-25">
          <span v-if="!editMode && modelCopy.closingDate===null">?</span>
          <span v-if="!editMode && modelCopy.closingDate!==null">{{getFormatedDate(modelCopy.closingDate)}}</span>
          <input v-if="editMode" type="date" v-model="modelCopy.inputClosingDate" ref="closingDate" name="closingDate" :min="dateMin" :max="dateMax"  v-validate="'date_format:yyyy-mm-dd|isDateBigger:openingDate'" :class="{'field-validation-error': errors.has('closingDate')}"/>
        </div>
      </div>
      <div class="row">
        <div class="col col-16">{{$resx('FaqReceptionLateArrivalAllowedText')}}</div>
        <div class="col col-16">
          <span v-if="!editMode && modelCopy.lateArrivalAllowed===null">?</span>
          <i v-if="!editMode && modelCopy.lateArrivalAllowed!==null" class='material-icons'>{{getCheckStateClass(modelCopy.lateArrivalAllowed)}}</i>
          <select v-if="editMode" v-model="modelCopy.lateArrivalAllowed">
            <option :value="null" disabled>?</option>
            <option :value="false">{{$resx('NoText')}}</option>
            <option :value="true">{{$resx('YesText')}}</option>
          </select>
        </div>
        <div v-if="modelCopy.lateArrivalAllowed===true" class="col">{{$resx('UntilText')}}</div>
        <div v-if="modelCopy.lateArrivalAllowed===true" class="col col-16">
          <span v-if="!editMode && modelCopy.lateArrivalLimitTime===null">?</span>
          <span v-if="!editMode && modelCopy.lateArrivalLimitTime!==null">{{getFormatedTime(modelCopy.lateArrivalLimitTime)}}</span>
          <input v-if="editMode" type="time" v-model="modelCopy.inputLateArrivalLimitTime" ref="lateArrivalLimitTime" name="lateArrivalLimitTime" />
        </div>
        <div v-if="modelCopy.lateArrivalAllowed===true" class="col">{{$resx('FaqReceptionLatePhoneText')}}</div>
        <div v-if="modelCopy.lateArrivalAllowed===true" class="col col-16">
          <span v-if="!editMode && modelCopy.lateArrivalPhone===null">?</span>
          <span v-if="!editMode && modelCopy.lateArrivalPhone!==null">{{modelCopy.lateArrivalPhone}}</span>
          <input v-if="editMode" type="tel" v-model="modelCopy.lateArrivalPhone" maxlength="50" />
        </div>
      </div>
        <div class="row">
          <div class="col col-25">{{$resx('FaqReceptionGateClosingTime')}}</div>
          <div class="col col-25">
            <span v-if="!editMode && modelCopy.gateClosingTime===null">?</span>
            <span v-if="!editMode && modelCopy.gateClosingTime!==null">{{getFormatedTime(modelCopy.gateClosingTime)}}</span>
            <input v-if="editMode" type="time" v-model="modelCopy.inputGateClosingTime" ref="gateClosingTime" name="gateClosingTime" />
          </div>
        </div>
        <div class="row">
          <div class="col col-50">{{$resx('FaqReceptionLowSeasonHoursText')}}</div>
          <div class="col">{{$resx('FromText')}}</div>
          <div class="col col-16">
            <span v-if="!editMode && modelCopy.lowSeasonOpeningTime===null">?</span>
            <span v-if="!editMode && modelCopy.lowSeasonOpeningTime!==null">{{getFormatedTime(modelCopy.lowSeasonOpeningTime)}}</span>
            <input v-if="editMode" type="time" v-model="modelCopy.inputLowSeasonOpeningTime" ref="lowSeasonOpeningTime" name="lowSeasonOpeningTime" :class="{'field-validation-error': errors.has('lowSeasonOpeningTime')}" />
          </div>
          <div class="col">{{$resx('ToText')}}</div>
          <div class="col col-16">
            <span v-if="!editMode && modelCopy.lowSeasonClosingTime===null">?</span>
            <span v-if="!editMode && modelCopy.lowSeasonClosingTime!==null">{{getFormatedTime(modelCopy.lowSeasonClosingTime)}}</span>
            <input v-if="editMode" type="time" v-model="modelCopy.inputLowSeasonClosingTime" name="lowSeasonClosingTime" v-validate="'isDateBigger:lowSeasonOpeningTime'" :class="{'field-validation-error': errors.has('lowSeasonClosingTime')}" />
          </div>
        </div>
        <div class="row">
          <div class="col col-50">{{$resx('FaqReceptionHighSeasonHoursText')}}</div>
          <div class="col">{{$resx('FromText')}}</div>
          <div class="col col-16">
            <span v-if="!editMode && modelCopy.highSeasonOpeningTime===null">?</span>
            <span v-if="!editMode && modelCopy.highSeasonOpeningTime!==null">{{getFormatedTime(modelCopy.highSeasonOpeningTime)}}</span>
            <input v-if="editMode" type="time" v-model="modelCopy.inputHighSeasonOpeningTime" ref="highSeasonOpeningTime" name="highSeasonOpeningTime" :class="{'field-validation-error': errors.has('highSeasonOpeningTime')}" />
          </div>
          <div class="col">{{$resx('ToText')}}</div>
          <div class="col col-16">
            <span v-if="!editMode && modelCopy.highSeasonClosingTime===null">?</span>
            <span v-if="!editMode && modelCopy.highSeasonClosingTime!==null">{{getFormatedTime(modelCopy.highSeasonClosingTime)}}</span>
            <input v-if="editMode" type="time" v-model="modelCopy.inputHighSeasonClosingTime" name="highSeasonClosingTime" v-validate="'isDateBigger:highSeasonOpeningTime'" :class="{'field-validation-error': errors.has('highSeasonClosingTime')}" />
          </div>
        </div>
        <div class="row">
          <div class="col col-50">{{$resx('FaqReceptionArrivalHoursRentalText')}}</div>
          <div class="col">{{$resx('FromText')}}</div>
          <div class="col col-16">
            <span v-if="!editMode && modelCopy.rentalArrivalStartTime===null">?</span>
            <span v-if="!editMode && modelCopy.rentalArrivalStartTime!==null">{{getFormatedTime(modelCopy.rentalArrivalStartTime)}}</span>
            <input v-if="editMode" type="time" v-model="modelCopy.inputRentalArrivalStartTime" ref="rentalArrivalStartTime" name="rentalArrivalStartTime" :class="{'field-validation-error': errors.has('rentalArrivalStartTime')}" />
          </div>
          <div class="col">{{$resx('ToText')}}</div>
          <div class="col col-16">
            <span v-if="!editMode && modelCopy.rentalArrivalEndTime===null">?</span>
            <span v-if="!editMode && modelCopy.rentalArrivalEndTime!==null">{{getFormatedTime(modelCopy.rentalArrivalEndTime)}}</span>
            <input v-if="editMode" type="time" v-model="modelCopy.inputRentalArrivalEndTime" name="rentalArrivalEndTime" v-validate="'isDateBigger:rentalArrivalStartTime'" :class="{'field-validation-error': errors.has('rentalArrivalEndTime')}" />
          </div>
        </div>
        <div class="row">
          <div class="col col-50">{{$resx('FaqReceptionDepartureHoursRentalText')}}</div>
          <div class="col">{{$resx('FromText')}}</div>
          <div class="col col-16">
            <span v-if="!editMode && modelCopy.rentalDepartureStartTime===null">?</span>
            <span v-if="!editMode && modelCopy.rentalDepartureStartTime!==null">{{getFormatedTime(modelCopy.rentalDepartureStartTime)}}</span>
            <input v-if="editMode" type="time" v-model="modelCopy.inputRentalDepartureStartTime" ref="rentalDepartureStartTime" name="rentalDepartureStartTime" :class="{'field-validation-error': errors.has('rentalDepartureStartTime')}" />
          </div>
          <div class="col">{{$resx('ToText')}}</div>
          <div class="col col-16">
            <span v-if="!editMode && modelCopy.rentalDepartureEndTime===null">?</span>
            <span v-if="!editMode && modelCopy.rentalDepartureEndTime!==null">{{getFormatedTime(modelCopy.rentalDepartureEndTime)}}</span>
            <input v-if="editMode" type="time" v-model="modelCopy.inputRentalDepartureEndTime" name="rentalDepartureEndTime" v-validate="'isDateBigger:rentalDepartureStartTime'" :class="{'field-validation-error': errors.has('rentalDepartureEndTime')}" />
          </div>
        </div>
        <div class="row">
          <div class="col col-50">{{$resx('FaqReceptionArrivalHoursPitchText')}}</div>
          <div class="col">{{$resx('FromText')}}</div>
          <div class="col col-16">
            <span v-if="!editMode && modelCopy.pitchArrivalStartTime===null">?</span>
            <span v-if="!editMode && modelCopy.pitchArrivalStartTime!==null">{{getFormatedTime(modelCopy.pitchArrivalStartTime)}}</span>
            <input v-if="editMode" type="time" v-model="modelCopy.inputPitchArrivalStartTime" ref="pitchArrivalStartTime" name="pitchArrivalStartTime" :class="{'field-validation-error': errors.has('pitchArrivalStartTime')}" />
          </div>
          <div class="col">{{$resx('ToText')}}</div>
          <div class="col col-16">
            <span v-if="!editMode && modelCopy.pitchArrivalEndTime===null">?</span>
            <span v-if="!editMode && modelCopy.pitchArrivalEndTime!==null">{{getFormatedTime(modelCopy.pitchArrivalEndTime)}}</span>
            <input v-if="editMode" type="time" v-model="modelCopy.inputPitchArrivalEndTime" name="pitchArrivalEndTime" v-validate="'isDateBigger:pitchArrivalStartTime'" :class="{'field-validation-error': errors.has('pitchArrivalEndTime')}" />
          </div>
        </div>
        <div class="row">
          <div class="col col-50">{{$resx('FaqReceptionDepartureHoursPitchText')}}</div>
          <div class="col">{{$resx('FromText')}}</div>
          <div class="col col-16">
            <span v-if="!editMode && modelCopy.pitchDepartureStartTime===null">?</span>
            <span v-if="!editMode && modelCopy.pitchDepartureStartTime!==null">{{getFormatedTime(modelCopy.pitchDepartureStartTime)}}</span>
            <input v-if="editMode" type="time" v-model="modelCopy.inputPitchDepartureStartTime" ref="pitchDepartureStartTime" name="pitchDepartureStartTime" :class="{'field-validation-error': errors.has('pitchDepartureStartTime')}" />
          </div>
          <div class="col">{{$resx('ToText')}}</div>
          <div class="col col-16">
            <span v-if="!editMode && modelCopy.pitchDepartureEndTime===null">?</span>
            <span v-if="!editMode && modelCopy.pitchDepartureEndTime!==null">{{getFormatedTime(modelCopy.pitchDepartureEndTime)}}</span>
            <input v-if="editMode" type="time" v-model="modelCopy.inputPitchDepartureEndTime" name="pitchDepartureEndTime" v-validate="'isDateBigger:pitchDepartureStartTime'" :class="{'field-validation-error': errors.has('pitchDepartureEndTime')}" />
          </div>
        </div>
      </div>
      <div v-else class="faq-bloc-body text-center">
        <i class="loading material-icons">cached</i>
      </div>
      <div class="faq-bloc-footer">
        <button v-show="!editMode" class="btn btn-secondary" @click="editMode=true">{{$resx('EditText')}}</button>
        <button v-show="editMode" class="btn btn-secondary" @click="editMode=false">{{$resx('CancelText')}}</button>
        <button v-show="editMode" style="margin-left:.5em" class="btn btn-primary" @click="save" :disabled="isSaving">{{$resx('SaveText')}}</button>
      </div>
    </div>
</template>
<script>
import faqServices from '../../services/faqServices'
import FaqReception from '../../models/faq/faqReception'
import helperServices from '../../services/helperServices'
var moment = require('moment')

export default {
  props: {
    reception: null
  },
  data () {
    return {
      isSaving: false,
      editMode: false,
      modelCopy: null,
      dateMin: null,
      dateMax: null
    }
  },
  computed: {
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    },

    lateArrivalAllowed () {
      return this.modelCopy !== null && this.modelCopy.lateArrivalAllowed != null && this.modelCopy.lateArrivalAllowed === true
    }

  },
  watch: {
    editMode: function (val) {
      this.modelCopy = this.copyFullObject(this.reception)
    },

    lateArrivalAllowed: function () {
      // console.log('watch lateArrivalAllowed')
      if (!this.lateArrivalAllowed) {
        this.modelCopy.lateArrivalLimitTime = null
        this.modelCopy.inputLateArrivalLimitTime = null
        this.modelCopy.lateArrivalPhone = null
      }
    }
  },
  methods:
  {
    // Copie de l'objet référence dans une autre variable
    copyFullObject: function (source) {
      let newObj = {}
      if (source !== null) {
        newObj = new FaqReception(source)
      }
      return newObj
    },

    // retourne l'icone pour indiquer le statut d'un item
    getCheckStateClass: function (value) {
      if (value === null) {
        return 'fa-question'
      } else {
        return value ? 'check' : 'close'
      }
    },

    // Retourne une date formatée pour le user
    getFormatedDate (jsonDate) {
      return helperServices.getFormatedDate(jsonDate)
    },

    // Retourne une heure formatée pour le user
    getFormatedTime (jsonTime) {
      return helperServices.getFormatedTime(jsonTime)
    },

    // sauvegarde des infos
    save: function () {
      const self = this
      self.isSaving = true

      // copie des dates et heure
      this.modelCopy.openingDate = helperServices.getDateFromInput(this.modelCopy.inputOpeningDate)
      this.modelCopy.closingDate = helperServices.getDateFromInput(this.modelCopy.inputClosingDate)
      this.modelCopy.gateClosingTime = helperServices.getTimeFromInput(this.modelCopy.inputGateClosingTime)
      this.modelCopy.highSeasonClosingTime = helperServices.getTimeFromInput(this.modelCopy.inputHighSeasonClosingTime)
      this.modelCopy.highSeasonOpeningTime = helperServices.getTimeFromInput(this.modelCopy.inputHighSeasonOpeningTime)
      this.modelCopy.lateArrivalLimitTime = helperServices.getTimeFromInput(this.modelCopy.inputLateArrivalLimitTime)
      this.modelCopy.lowSeasonClosingTime = helperServices.getTimeFromInput(this.modelCopy.inputLowSeasonClosingTime)
      this.modelCopy.lowSeasonOpeningTime = helperServices.getTimeFromInput(this.modelCopy.inputLowSeasonOpeningTime)
      this.modelCopy.pitchArrivalEndTime = helperServices.getTimeFromInput(this.modelCopy.inputPitchArrivalEndTime)
      this.modelCopy.pitchArrivalStartTime = helperServices.getTimeFromInput(this.modelCopy.inputPitchArrivalStartTime)
      this.modelCopy.pitchDepartureEndTime = helperServices.getTimeFromInput(this.modelCopy.inputPitchDepartureEndTime)
      this.modelCopy.pitchDepartureStartTime = helperServices.getTimeFromInput(this.modelCopy.inputPitchDepartureStartTime)
      this.modelCopy.rentalArrivalEndTime = helperServices.getTimeFromInput(this.modelCopy.inputRentalArrivalEndTime)
      this.modelCopy.rentalArrivalStartTime = helperServices.getTimeFromInput(this.modelCopy.inputRentalArrivalStartTime)
      this.modelCopy.rentalDepartureEndTime = helperServices.getTimeFromInput(this.modelCopy.inputRentalDepartureEndTime)
      this.modelCopy.rentalDepartureStartTime = helperServices.getTimeFromInput(this.modelCopy.inputRentalDepartureStartTime)

      faqServices.saveFaqReception(this.currentCampingId, this.modelCopy)
        .then(response => {
          // signaler l'update au parent
          self.$emit('update-items', this.copyFullObject(this.modelCopy))
          self.isSaving = false
          self.editMode = false
          const message = self.$resx('FaqSavedText')
          self.$store.commit('app/showSnack', { type: 'success', message: message })
        })
        .catch(error => {
          self.isSaving = false
          self.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
        })
    }
  },
  created: function () {
    // console.log('reception created')
    this.modelCopy = this.copyFullObject(this.reception)
    this.dateMin = moment().format('YYYY-01-01')
    this.dateMax = moment().add(1, 'year').format('YYYY-12-31')
  }
}
</script>
